module.exports = function(){



    /*------------------------------------*\
        Same As Billing Address Stuff
    \*------------------------------------*/


    var inputSelector = '[js-same-as-billing-address-input]';
    var input = $(inputSelector);
    var fields = $('[js-same-as-billing-address-fields]');










    var copyBillingAddressValuesToShippingAndSubmit = function(callback){

        // forms
        var formBilling = $('.js-billing-address-form');
        var formShipping = $('.js-home-address-form');


        // normal input copies
        var formBillingAddressLine1 = formBilling.find('input[name="AddressLine1"]').val();
        formShipping.find('input[name="AddressLine1"]').val( formBillingAddressLine1 );

        var formBillingCity = formBilling.find('input[name="City"]').val();
        formShipping.find('input[name="City"]').val( formBillingCity );

        var formBillingZipCode = formBilling.find('input[name="ZipCode"]').val();
        formShipping.find('input[name="ZipCode"]').val( formBillingZipCode );



        // selectize copies
        var formBillingCountrySelect = formBilling.find('.js-address-country');
        var formBillingStateSelect = formBilling.find('.js-address-state');

        var formShippingCountrySelect = formShipping.find('.js-address-country');
        var formShippingStateSelect = formShipping.find('.js-address-state');

        //var formBillingCountrySelectize = formBillingCountrySelect[0].selectize;
        //var formBillingStateSelectize = formBillingStateSelect[0].selectize;

        var formShippingCountrySelectize = formShippingCountrySelect[0].selectize;
        var formShippingStateSelectize = formShippingStateSelect[0].selectize;

        var formBillingCountryVal = formBillingCountrySelect.val();
        var formBillingStateVal = formBillingStateSelect.val();




        // set selectize vals
        formShippingCountrySelectize.setValue(formBillingCountryVal, 1);
        formShipping.find('.js-address-country').trigger('sameasbillingcopied');
        formShippingStateSelectize.setValue(formBillingStateVal, 1);


        // submit
        $('.js-home-address-form').trigger('submit');

        callback.call(this);

    };








    var checkedHandler = function(){



        if (input.is(':checked')) {
            fields.addClass('is-disabled');
            //fields.find('input, textarea, select').prop('disabled', true);

            eph.setSameAddress({
                value: 1,
                success: function(data, textStatus, jqXHR){
                },
                complete: function(jqXHR, textStatus){
                },
            });


        } else {
            fields.removeClass('is-disabled');
            //fields.find('input, textarea, select').prop('disabled', false);

            eph.setSameAddress({
                value: 0,
                success: function(data, textStatus, jqXHR){
                },
                complete: function(jqXHR, textStatus){
                },
            });

        }
    };




    $(document).on('click', inputSelector, function(event) {

        var formBilling = $('.js-billing-address-form');
        var formBillingAddressLine1 = formBilling.find('input[name="AddressLine1"]').val().length;

        if (!formBillingAddressLine1) {
            alertify.alert('We can\'t do that because you billing address is empty.');
            return false;
        }

    });


    $(document).on('change', inputSelector, function(event) {

        if (input.is(':checked')) {
            copyBillingAddressValuesToShippingAndSubmit(function(){});
        }
        checkedHandler();

    });








    eph.getSameAddress({
        success: function(data, textStatus, jqXHR){
            input.prop('checked', data.SameAddress);
            checkedHandler();
        },
        complete: function(jqXHR, textStatus){
        },
    });





    /*------------------------------------*\
        / Same As Billing Address Stuff
    \*------------------------------------*/












}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/same-as-billing-address.js